import { RouteItem } from '@eastcoal/router/types/route'

export const debuggerRoute: RouteItem = {
  title: '调试工具',
  path: '/debugger',
  hideInMenu: true,
  Component: () => import('@eastcoal/common/components/Debugger')
}
